export const StateIDs = {
  UnknownState: 'cbcd1aa0-cd3b-4b14-9d8c-76015cffe3a4'
};
